import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
const testimonials = [{
  quote: 'Lo mandé a imprimir en la gráfica del barrio en papel ilustración. Me salió mejor que cualquier cosa que encontré en el mercado. El mate y el truco, no hay mejor combo.',
  author: 'Matías G.',
  location: 'Buenos Aires',
  rating: 4,
  image: 'https://cdn.magicpatterns.com/uploads/7xp4Xng8GuaR6bNxuQdmku/7837f403-8435-4ed0-96b6-51d80de7283d.png',
  timeAgo: 'Hace 3 días'
}, {
  quote: 'Se lo compré a mis hijos para que jueguen en casa. No pararon en toda la tarde. La cara de felicidad cuando vieron las cartas no tiene precio.',
  author: 'Carolina M.',
  location: 'Rosario',
  rating: 4.5,
  image: 'https://cdn.magicpatterns.com/uploads/a1NERkdM8oWQF5PtVRZMhM/194a4973-4def-4489-8d69-4317935e28bf.png',
  timeAgo: 'Hace 1 semana'
}, {
  quote: 'Pensé que iba a ser un diseño genérico. La calidad del archivo y el detalle en cada carta me sorprendió. Ya lo llevé al asado y fue un éxito total.',
  author: 'Rodrigo T.',
  location: 'Córdoba',
  rating: 5,
  image: 'https://cdn.magicpatterns.com/uploads/1oiV1JhSu6sJF5aG2JuYJM/28125b73-09ba-4926-9722-fb055c50d975.png',
  timeAgo: 'Hace 5 días'
}];
export function Testimonials() {
  return <section className="py-10 px-4 bg-navy-900 relative" data-id="element-318">
      <div className="max-w-6xl mx-auto" data-id="element-319">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-4xl md:text-5xl font-bebas text-white text-center mb-4" data-id="element-320">
          Lo que dicen los que ya lo tienen
        </motion.h2>
        <div className="grid md:grid-cols-3 gap-6 mt-10" data-id="element-321">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.15
        }} className="bg-navy-800 rounded-2xl border border-white/5 overflow-hidden hover:border-gold/30 transition-colors" data-id="element-322">
              {/* User photo */}
              <div className="w-full overflow-hidden" data-id="element-323">
                <img src={t.image} alt={`Reseña de ${t.author}`} className="w-full h-auto object-cover" data-id="element-324" />
              </div>

              <div className="p-6 relative" data-id="element-325">
                <Quote className="w-7 h-7 text-white/5 absolute top-4 right-4" data-id="element-326" />

                {/* Stars */}
                <div className="flex gap-1 mb-3" data-id="element-327">
                  {[...Array(5)].map((_, index) => {
                const starValue = index + 1;
                if (starValue <= t.rating) {
                  return <Star key={index} className="w-4 h-4 text-gold fill-gold" data-id="element-328" />;
                } else if (starValue - 0.5 === t.rating) {
                  return <div key={index} className="relative w-4 h-4" data-id="element-329">
                          <Star className="w-4 h-4 text-gold absolute" data-id="element-330" />
                          <div className="absolute inset-0 overflow-hidden w-[50%]" data-id="element-331">
                            <Star className="w-4 h-4 text-gold fill-gold" data-id="element-332" />
                          </div>
                        </div>;
                }
                return <Star key={index} className="w-4 h-4 text-gold/30" data-id="element-333" />;
              })}
                </div>

                <p className="text-white/90 leading-relaxed mb-4 text-[15px]" data-id="element-334">
                  "{t.quote}"
                </p>

                <div className="flex items-center justify-between" data-id="element-335">
                  <div data-id="element-336">
                    <span className="text-white font-semibold text-sm" data-id="element-337">
                      {t.author}
                    </span>
                    <span className="text-white/40 mx-1.5" data-id="element-338">·</span>
                    <span className="text-white/50 text-sm" data-id="element-339">{t.location}</span>
                  </div>
                  <span className="text-white/30 text-xs" data-id="element-340">{t.timeAgo}</span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}